import { motion, useReducedMotion, type HTMLMotionProps } from 'framer-motion'
import type { ReactNode, CSSProperties } from 'react'

interface ScrollRevealProps extends Omit<HTMLMotionProps<'div'>, 'children' | 'style'> {
  children: ReactNode
  delay?: number
  style?: CSSProperties
  className?: string
}

const easeOut: [number, number, number, number] = [0, 0, 0.58, 1]

export default function ScrollReveal({
  children,
  delay = 0,
  style,
  className,
  ...rest
}: ScrollRevealProps) {
  const reduceMotion = useReducedMotion()

  if (reduceMotion) {
    return (
      <div style={style} className={className}>
        {children}
      </div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12, margin: '0px 0px -40px 0px' }}
      transition={{ duration: 0.5, ease: easeOut, delay }}
      style={style}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  )
}
